<template>
  <md-card class="md-layout-item md-size-20">
    <md-card-media-actions>
      <md-card-media>
        <img :src="getAvatarURL()" />
      </md-card-media>

      <md-card-actions>
        <md-button class="md-icon-button" @click="$refs.uploadAvatarEdit.click()">
          <input type="file" style="display:none;" ref="uploadAvatarEdit" @change="editAvatar" />
          <md-icon>create</md-icon>
        </md-button>

        <md-button class="md-icon-button" @click="$emit('avatarDelete', avatar)">
          <md-icon>delete</md-icon>
        </md-button>
      </md-card-actions>
    </md-card-media-actions>
  </md-card>
</template>

<script>
export default {
  props: {
    avatar: {
      type: Object,
      required: true
    }
  },
  methods: {
    getAvatarURL(name) {
      return `${process.env.VUE_APP_CDN_URL_AVATARS}${this.avatar.avatar}`;
    },
    editAvatar(ev) {
      this.$emit("avatarEdit", { ev, avatar: this.avatar });
    }
  }
};
</script>
